module.exports = __webpack_public_path__ + "img/addimg.17d95c21.jpg";